import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';

import DataTable from '../../../sharedModules/dataTable/DataTable/DataTable';
import { IDataTableColumn } from '../../../sharedModules/dataTable/DataTable/model';

import { Team } from '../model';

import axios from '../../../sharedModules/utils/axios.utils';

const teamData = [
  { name: 'MASTACIO', members: ['Angiellari, Johan', 'Barnett, Gary', 'Duarte, Johnathan'] },
  { name: 'MBERGER', members: ['Dwyer, Patrick'] },
  { name: 'MCLAWSON', members: ['Cardwell, Devin', 'Embler, Brandyn', 'Lundy, David'] },
  { name: 'MPATTON', members: ['Astacio, Tony', 'Berger, Chris', 'Clawson, Dave', 'Simmons, Michael'] },
  { name: 'MTANKOSIC', members: ['Henson, Brandon', 'Christian, Neal', 'Zinkevitch, Sergey'] },
  { name: 'MZARADICH', members: ['Farramola, Joelly', 'Grinder, Cory', 'Hernandez, Gabriel'] },
  {
    name: 'SERVICE',
    members: [
      'Clawson, Dylan',
      'Higgins, Brad',
      'Kearns, Jim',
      'Nelson, Chris',
      'Ransom, Travis',
      'Sanders, Don',
      'Ward, James',
      'Wiedenbeck, Joe',
      'Zambo, Brennan',
    ],
  },
];

const columns: IDataTableColumn<any>[] = [
  {
    name: 'Team Name',
    selector: 'name',
    sortable: true,
    width: '150px',
  },
  {
    name: 'Team Mentor',
    selector: 'leader_name',
    sortable: true,
    width: '180px',
    cell: (row) => row.leader_name || '-',
  },
  {
    name: 'Members',
    selector: 'members',
    grow: 3,
    cell: (row) => (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {row.member_list?.map((member: string, index: number) => (
          <Chip key={index} label={member} size="small" variant="outlined" sx={{ margin: 0.25 }} />
        ))}
      </Box>
    ),
  },
];

const TeamsListPage: React.FunctionComponent = () => {
  const history = useHistory();

  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const fetchTeams = async () => {
    setLoading(true);
    try {
      const response: any = await axios.get('/teams');
      setTeams(response.data.result);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  return (
    <LoadingWrapper isLoading={loading}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h5" component="h5" style={{ marginTop: 5 }}>
            Teams
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ErrorMessage message={errorMessage} />
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <DataTable
                title="Users"
                columns={columns}
                data={teams}
                striped
                dense
                highlightOnHover
                pointerOnHover
                noHeader
                pagination
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </LoadingWrapper>
  );
};

export default TeamsListPage;
